
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  EmptyState,
  EmptyStateVariation,
  Button,
  Category,
  Tier,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Empty State`}</h1>
<p>{`Used on a neutral background, can display some information about the page/page section and what is going on. It contains a row of actions at the bottom, these are usually `}<inlineCode parentName="p">{`Button`}</inlineCode>{`s.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { EmptyState } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<EmptyState
  title="This place is empty"
  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ">
  <Button tier={Tier.SECONDARY}>Cancel</Button>
  <Button category={Category.BRAND}>Go to home</Button>
</EmptyState>`} component={EmptyState} enums={{
      EmptyStateVariation
    }} mdxType="Playground">
  <EmptyState title="This place is empty" description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. " mdxType="EmptyState">
    <Button tier={Tier.SECONDARY} mdxType="Button">Cancel</Button>
    <Button category={Category.BRAND} mdxType="Button">Go to home</Button>
  </EmptyState>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;